export default __webpack_public_path__ + "static/media/vultr.050f2ac0.svg";